import { render } from "./FiltreCurrentOrder.vue?vue&type=template&id=b3784688"
import script from "./FiltreCurrentOrder.vue?vue&type=script&lang=ts"
export * from "./FiltreCurrentOrder.vue?vue&type=script&lang=ts"
script.render = render

export default script